import Award from '../sectionBlocks/Awards';
import Footer from '../sectionBlocks/Footer';
import RoadMapSection from "../sectionBlocks/RoadMapSection";
import RoadMap from "../sectionBlocks/WhitePaperSection";

const RoadMapPage = () => {
  return (
    <>
      <RoadMap/>
      <RoadMapSection/>
      <Award/>
      <Footer/>
    </>
  );
};

export default RoadMapPage;